import * as React from 'react';

export const ArrowTopLeftRounded: React.FC = () => {
  return (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5 1C4.63401 1 1.5 4.13401 1.5 8C1.5 11.866 4.63401 15 8.5 15C12.366 15 15.5 11.866 15.5 8C15.5 4.13401 12.366 1 8.5 1ZM6.75 11.5V7.31066L10.9697 11.5303L12.0303 10.4697L7.81066 6.25H12V4.75L6 4.75H5.25V5.5V11.5L6.75 11.5Z"
        fill="black"
      />
    </svg>
  );
};
